import { Tooltip } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

import type { OwnershipSummaryOwnerRow } from './OwnershipSummaryHelper';

interface OwnershipDistributionBarProps {
  owners: OwnershipSummaryOwnerRow[];
  percentTotal: number;
}

export const OwnershipDistributionBar = ({
  owners,
  percentTotal,
}: OwnershipDistributionBarProps) => {
  // Over-allocated: scale by the real sum so the bar doesn't overflow.
  const denominator = Math.max(100, percentTotal);
  const segments = owners.filter((owner) => owner.percent > 0);

  return (
    <div className="flex flex-col gap-sm">
      <p className="txt-small-medium text-text-primary">
        Ownership distribution
      </p>
      <div className="flex h-2 w-full overflow-hidden rounded-full bg-bg-secondary">
        {segments.map((owner) => (
          <Tooltip
            key={owner.id}
            content={owner.name}
            supportingText={owner.percentLabel}
            side="top"
            asChild
          >
            <div
              className={cn(
                'h-full border-r border-white/60 last:border-r-0',
                owner.colorClassName
              )}
              style={{ width: `${(owner.percent / denominator) * 100}%` }}
            />
          </Tooltip>
        ))}
      </div>
      <ul className="flex flex-wrap gap-x-xl gap-y-xs">
        {segments.map((owner) => (
          <li
            key={owner.id}
            className="flex items-center gap-xs txt-extra-small-regular text-text-secondary"
          >
            <span
              aria-hidden
              className={cn(
                'size-2 shrink-0 rounded-full',
                owner.colorClassName
              )}
            />
            <span>{owner.name}</span>
            <span className="txt-extra-small-medium text-text-primary">
              {owner.percentLabel}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
